import { client } from "./client";
import {
  ProjectCreateRequest,
  ProjectUpdateRequest,
} from "../types/Project";
import {
  ProjectTaskCreateRequest,
  ProjectTaskInputCreateRequest,
  ProjectTaskUpdateRequest,
} from "../types/ProjectTask";

export function apiCreateProject(
  organizationId: number,
  workspaceId: number,
  projectCreateRequest: ProjectCreateRequest
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/projects`,
    projectCreateRequest
  );
}

export function apiGetProjects(
  organizationId: number,
  workspaceId: number
) {
  return client.get(
    `/organizations/${organizationId}/workspaces/${workspaceId}/projects`
  );
}

export function apiUpdateProject(
  organizationId: number,
  workspaceId: number,
  projectId: number,
  projectUpdateRequest: ProjectUpdateRequest
) {
  return client.put(
    `/organizations/${organizationId}/workspaces/${workspaceId}/projects/${projectId}`,
    projectUpdateRequest
  );
}

export function apiGetProjectTasks(
  organizationId: number,
  workspaceId: number,
  projectId: number
) {
  return client.get(
    `/organizations/${organizationId}/workspaces/${workspaceId}/projects/${projectId}`
  );
}

export function apiCreateProjectTask(
  organizationId: number,
  workspaceId: number,
  projectId: number,
  projectTaskCreateRequest: ProjectTaskCreateRequest
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/projects/${projectId}/tasks`,
    projectTaskCreateRequest
  );
}

export function apiUpdateProjectTask(
  organizationId: number,
  workspaceId: number,
  projectId: number,
  taskId: number,
  projectTaskUpdateRequest: ProjectTaskUpdateRequest
) {
  return client.put(
    `/organizations/${organizationId}/workspaces/${workspaceId}/projects/${projectId}/tasks/${taskId}`,
    projectTaskUpdateRequest
  );
}

export function apiGetProjectTask(
  organizationId: number,
  workspaceId: number,
  projectId: number,
  taskId: number
) {
  return client.get(
    `/organizations/${organizationId}/workspaces/${workspaceId}/projects/${projectId}/tasks/${taskId}`
  );
}

export function apiCreateProjectTaskInput(
  organizationId: number,
  workspaceId: number,
  projectId: number,
  taskId: number,
  projectTaskInputCreateRequest: ProjectTaskInputCreateRequest
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/projects/${projectId}/tasks/${taskId}/inputs`,
    projectTaskInputCreateRequest
  );
}

export function apiUpdateProjectTaskInput(
  organizationId: number,
  workspaceId: number,
  projectId: number,
  taskId: number,
  inputId: number,
  projectTaskInputCreateRequest: ProjectTaskInputCreateRequest
) {
  return client.put(
    `/organizations/${organizationId}/workspaces/${workspaceId}/projects/${projectId}/tasks/${taskId}/inputs/${inputId}`,
    projectTaskInputCreateRequest
  );
}

export function apiToggleProjectTaskInput(
  organizationId: number,
  workspaceId: number,
  projectId: number,
  taskId: number,
  inputId: number,
  toProcess: number
) {
  return client.put(
    `/organizations/${organizationId}/workspaces/${workspaceId}/projects/${projectId}/tasks/${taskId}/toggle_inputs/${inputId}`,
    { to_process: toProcess }
  );
}

export function apiDeleteProjectTaskInput(
  organizationId: number,
  workspaceId: number,
  projectId: number,
  taskId: number,
  inputId: number
) {
  return client.delete(
    `/organizations/${organizationId}/workspaces/${workspaceId}/projects/${projectId}/tasks/${taskId}/inputs/${inputId}`
  );
}
